import { createContext, Dispatch, SetStateAction } from "react";
import type { SettingType, TownType } from "../Structures";

type MainContextType = {
  setting: SettingType;
  setSetting: Dispatch<SetStateAction<SettingType>>;
  townList: TownType[];
  setTownList: Dispatch<SetStateAction<TownType[]>>;
};

const MainContext = createContext<MainContextType>({
  setting: {
    first_image: "",
    second_image: "",
    third_image: "",
    forth_image: "",
    blog_banner: "",
    coach_banner: "",
    event_banner: "",
    gallery_banner: "",
    about_banner: "",
    rule_banner: "",
    first_title: "",
    second_title: "",
    third_title: "",
    forth_title: "",
    cart_sheba: "",
    cart_number: "",
    account_number: "",
    owner_cart: "",
    officePhone: "",
    phone: "",
    workTime: "",
    address: "",
    email: "",
    copyright: "",
    telegramLink: "",
    whatsappLink: "",
    instagramLink: "",
    mapLink: "",
    is_loading: false,
  },
  setSetting: () => {},
  townList: [],
  setTownList: () => {},
});

export default MainContext;
